var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageViewHeaderWithActionBar',{attrs:{"title":'좋아요를 누른 사람'}}),_c('RecommendContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }